import { render, staticRenderFns } from "./LocalVideo.vue?vue&type=template&id=f5815f02&scoped=true&"
import script from "./LocalVideo.vue?vue&type=script&lang=js&"
export * from "./LocalVideo.vue?vue&type=script&lang=js&"
import style0 from "./LocalVideo.vue?vue&type=style&index=0&id=f5815f02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5815f02",
  null
  
)

export default component.exports